import {
  ColumnContainer,
  ColumnImageContainer,
  ColumnRedesSociais,
  FacebookIcon,
  FooterContainer,
  InstagramIcon,
  RedesSociais,
  YoutubeIcon
} from "./styles";

import bannerLojas from "../../assets/images/home/banners/bannerclinicas.png";

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <ColumnImageContainer>
        <img
          style={{ width: "100%", height: "100%" }}
          src={bannerLojas}
          alt="Lojas parceiras"
        />
      </ColumnImageContainer>

      <ColumnContainer>
        <h2>Contato</h2>
        <p>
          Rua Dezesseis de Março, 38 - Sala 6 - Petrópolis/RJ
        </p>
        <p>(24) 2017-8904</p>
      </ColumnContainer>

      <ColumnRedesSociais>
        <h2>Redes Sociais</h2>
        <RedesSociais>
          <a
            href="https://www.facebook.com/share/1HjPzs8E8X/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook da AFESP"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.youtube.com/@afespconvenios"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube da AFESP"
          >
            <YoutubeIcon />
          </a>
          <a
            href="https://www.instagram.com/afesppetropolis"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram da AFESP"
          >
            <InstagramIcon />
          </a>
        </RedesSociais>
      </ColumnRedesSociais>
    </FooterContainer>
  );
};
